export default class GeolocationAddress {
  constructor({streetNumber, street, city, postalCode, country}) {
    this.streetNumber = streetNumber;
    this.street = street;
    this.city = city;
    this.postalCode = postalCode;
    this.country = country;
  }
}
